function MarketplaceOrderEditOrderStepForm() {
	return {
		fields: [
			'orderStep.seller',
			'orderStep.id',
			'orderStep.orderNumber',
			'orderStep.shipByDate',
			'orderStep.deliverByDate',
			'orderStep.orderDate',
			'orderStep.amountPaid',
			'orderStep.internalNote',
			'orderStep.orderType',
			'orderStep.ref1',
			'orderStep.ref2',
			'orderStep.ref3',
			'orderStep.paymentDate',
			'orderStep.channel',
			'orderStep.orderStatus',
		],
		labels: {
			'orderStep.seller': 'MARKETPLACEORDEREDITFORM.SELLER',
			'orderStep.orderNumber': 'MARKETPLACEORDEREDITFORM.ORDERNUMBER',
			'orderStep.shipByDate': 'MARKETPLACEORDEREDITFORM.SHIPBYDATE',
			'orderStep.deliverByDate': 'MARKETPLACEORDEREDITFORM.DELIVERBYDATE',
			'orderStep.orderDate': 'MARKETPLACEORDEREDITFORM.ORDERDATE',
			'orderStep.orderStatus': 'MARKETPLACEORDEREDITFORM.ORDERSTATUS',
			'orderStep.amountPaid': 'MARKETPLACEORDEREDITFORM.AMOUNTPAID',
			'orderStep.internalNote': 'MARKETPLACEORDEREDITFORM.INTERNALNOTE',
			'orderStep.orderType': 'MARKETPLACEORDEREDITFORM.ORDERTYPE',
			'orderStep.ref1': 'MARKETPLACEORDEREDITFORM.REF1',
			'orderStep.ref2': 'MARKETPLACEORDEREDITFORM.REF2',
			'orderStep.ref3': 'MARKETPLACEORDEREDITFORM.REF3',
			'orderStep.channel': 'MARKETPLACEORDEREDITFORM.CHANNEL',
			'orderStep.paymentDate': 'MARKETPLACEORDEREDITFORM.PAYMENTDATE',
			'orderStep.orderStatus': 'MARKETPLACEORDEREDITFORM.ORDERSTATUS',
		},
		rules: {
			'orderStep.orderNumber': 'required',
			'orderStep.shipByDate': 'required',
			'orderStep.orderDate': 'required',
			'orderStep.confirmationType': 'required',
			'orderStep.orderType': 'required',
			'orderStep.orderStatus': 'required',
			'orderStep.paymentDate': 'required',
		},
	};
}

export default MarketplaceOrderEditOrderStepForm;



// WEBPACK FOOTER //
// ./src/modules/order/forms/wizard/MarketplaceOrderEditOrderStepForm.js